import { render } from "./who.vue?vue&type=template&id=d01dc1b0&lang=pug"
import script from "./who.vue?vue&type=script&lang=js"
export * from "./who.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__